import { Injectable } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { devicePlatforms } from '../constants/device-platforms';

@Injectable({
  providedIn: 'root',
})
export class UtilityService {
  constructor(private deviceDetectorService: DeviceDetectorService) {}

  /**
   * Method to check if current device is `Android`.
   */
  isDeviceAndroid(deviceOS: string) {
    return deviceOS === devicePlatforms.android;
  }

  /**
   * Method to check if current device is `IOS`.
   */
  isDeviceIOS(deviceOS: string) {
    return deviceOS === devicePlatforms.ios || deviceOS === devicePlatforms.mac;
  }

  /**
   * Method to get device OS and check if web-app is opened in web-view or not.
   * @returns Object containing `deviceOS` and `isWebView` keys.
   */
  getDeviceOS() {
    const { os, browser } = this.deviceDetectorService.getDeviceInfo();
    const deviceOS = os.toLowerCase();
    const isDeviceAndroid = this.isDeviceAndroid(deviceOS);
    const isDeviceIOS = this.isDeviceIOS(deviceOS);

    const isWebView =
      (isDeviceAndroid &&
        (navigator.userAgent.includes('Version/') ||
          navigator.userAgent.includes('wv'))) ||
      (isDeviceIOS && browser === 'Unknown');

    return {
      deviceOS: isWebView ? deviceOS : 'web',
      isWebView,
    };
  }

  /**
   * Method to convert a single digit number (if provided) to double digit.
   * @param num - Single digit number.
   * @returns A double digit number.
   */
  convertTo2Digit(num: string) {
    return num.length > 1 ? num : `0${num}`;
  }

  /**
   * Method that returns current date in `DD-MM-YYYY HH:MM:SS` format.
   */
  getCurrentTS() {
    const currentTime = new Date();
    const currentDate = this.convertTo2Digit(String(currentTime.getDate()));
    const currentMonth = this.convertTo2Digit(
      String(currentTime.getMonth() + 1)
    );
    const currentYear = this.convertTo2Digit(String(currentTime.getFullYear()));
    const currentHour = this.convertTo2Digit(String(currentTime.getHours()));
    const currentMinutes = this.convertTo2Digit(
      String(currentTime.getMinutes())
    );
    const currentSecs = this.convertTo2Digit(String(currentTime.getSeconds()));

    return `${currentDate}-${currentMonth}-${currentYear} ${currentHour}:${currentMinutes}:${currentSecs}`;
  }

  /**
   * Method used to get nested value of an object.
   * @param object - Object from which nested value is to be extracted.
   * @param nestedKey - "." separated key indicating the nesting.
   * @returns Value extracted from the object (if any).
   */
  getNestedValue(object: any, nestedKey: string) {
    let value: any;
    const keys = nestedKey.split('.');

    keys.forEach((key) => {
      value = object?.[key];
    });

    return value;
  }

  /**
   * Method used to enfore numeric input to a text field.
   * @param event - Event of for the keyboard event.
   * @return A boolean value indicating to allow the input or not.
   */
  validateNumericInput(event: KeyboardEvent) {
    return !isNaN(+event.key);
  }

  /**
   * Method used to check whether the provided string is a substring or not.
   * @param firstStr The string which contains the substring.
   * @param secondStr The substring which is to be checked.
   * @returns - A boolean value indicating the result.
   */
  checkInString(firstStr: any, secondStr: any) {
    return String(firstStr || '')
      .toLowerCase()
      .trim()
      .includes(
        String(secondStr || '')
          .toLowerCase()
          .trim()
      );
  }

  checkIfTimeToRefresh(key:string) {
    const now = Date.now();
    const dashboardData:any = JSON.parse(<any> localStorage.getItem('dashboardData'))
    if(!dashboardData) return true
    if(!dashboardData[key]) return true
    const lastApiCallTime = (<any>JSON.parse(window.atob(dashboardData[key])))['lastApiCallTime'];
    const refreshInterval = 2 * 60 * 60 * 1000
    if (!lastApiCallTime || now - lastApiCallTime >= refreshInterval) {
      return true
    }
    return false
  }
}
